// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning[data-v-11ab79a1]{color:#ff7272}", ""]);
// Exports
module.exports = exports;
